import React, {
  useContext,
} from 'react';

import { Button, Divider } from '@mui/material';
import Cart from 'components/Cart';
import Overlay from 'components/Overlay';
import { env } from 'constants';
import { CartContext } from 'constants/contexts';
import OrderDetails from 'pages/Merchant/OrderDetails';
import useIsDesktop from 'hooks/useIsDesktop';
import CateringProvider from 'components/CateringProvider';

function CartOverlay() {
  const {
    openCart, isModalOpen, closeCart, items,
  } = useContext(CartContext);
  const isDesktop = useIsDesktop();

  function renderAction() {
    if (items.length === 0) {
      return (
        <Button fullWidth onClick={closeCart} variant="contained">
          close
        </Button>
      );
    }
    if (env.IS_CATERING) {
      return <CateringProvider.CartAction />;
    }
    return <Cart.Action sx={{ flex: 1 }} onClick={closeCart} />;
  }
  return (
    <Overlay
      open={isModalOpen}
      onClose={closeCart}
      onOpen={openCart}
      scroll="paper"
      hashKey="cart-button-cart"
      mobileFullScreen
      sx={{
        zIndex: (theme) => theme.zIndex.drawer - 1,
      }}
    >
      <Overlay.Header showClose={false} sx={{ p: 0 }}>
        <Cart.Header handleCloseCart={closeCart} />
      </Overlay.Header>
      <Overlay.Content sx={{ padding: 0 }}>
        {
          !isDesktop && env.IS_CATERING && (
            <>
              <OrderDetails />
              <Divider />
            </>
          )
        }
        <Cart.Items sx={{ padding: 2 }} />
      </Overlay.Content>
      <Overlay.Actions>
        {renderAction()}
      </Overlay.Actions>
    </Overlay>
  );
}
export default CartOverlay;
